import type { SketchfabConfig } from '#types/config/components/sketchfab'
import type { RecursivePartial } from '#types/utils'

export default {
  autoplay: false,
  icon: {
    src: 'https://assets.timberland.eu/image/upload/v1748261027/3d-icon.svg',
    width: 12,
    height: 12,
  }
} satisfies RecursivePartial<SketchfabConfig>
